<template>
  <label class="check-group">
    <input
      type="checkbox"
      :checked="value"
      :disabled="disabled"
      @change.prevent="($event) => onChange($event)">
    <span class="check"></span>
    <span
      class="label"
      v-if="label">
      {{ label }}
    </span>
  </label>
</template>

<script>
export default {
  name: 'Check',
  props: {
    label: {
      type: [String, Number],
      required: false,
      default: null,
    },
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onChange(event) {
      this.$emit('input', event.target.checked);
      // eslint-disable-next-line no-param-reassign
      event.target.checked = !event.target.checked;
    },
  },
};
</script>
